var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59998 7.2C7.59998 8.31391 8.04247 9.3822 8.83013 10.1698C9.61778 10.9575 10.6861 11.4 11.8 11.4C12.9139 11.4 13.9822 10.9575 14.7698 10.1698C15.5575 9.3822 16 8.31391 16 7.2C16 6.08609 15.5575 5.0178 14.7698 4.23015C13.9822 3.4425 12.9139 3 11.8 3C10.6861 3 9.61778 3.4425 8.83013 4.23015C8.04247 5.0178 7.59998 6.08609 7.59998 7.2V7.2Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 18.9313 4.82178 16.9474 6.28457 15.4846C7.74735 14.0218 9.73131 13.2 11.8 13.2C13.8687 13.2 15.8526 14.0218 17.3154 15.4846C18.7782 16.9474 19.6 18.9313 19.6 21",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ec43e9523918d3499cce6e6d757cabb7.svg";
export { ForwardRef as ReactComponent };